import { createContext } from "react";

import { SmartCaptchaContextType } from "./types";

export const SmartCaptchaContext = createContext<SmartCaptchaContextType | null>(null);
